import {
  BOOKS_SIMILAR_BOOKS_SET_DATA,
  BOOKS_SIMILAR_BOOKS_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  book: null,
  bookList: null,
};

export default function similarBooks(state = initialState, action) {
  switch (action.type) {
    case BOOKS_SIMILAR_BOOKS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_SIMILAR_BOOKS_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
